import { Assembly } from '@/assembly/api/types';
import { AssemblyBuildInformation } from '@/assembly/components/assembly-build-information';
import { AssemblyNotesTab } from '@/assembly/components/assembly-notes-tab';
import { AssemblyPartsUsed } from '@/assembly/components/assembly-parts-used';
import { Box, Tab, Tabs } from '@mui/material';
import { ReactNode, SyntheticEvent, useState } from 'react';

interface TabPanelProps {
  children?: ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`assembly-tabpanel-${index}`}
      aria-labelledby={`assembly-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
}

interface Props {
  assembly: Assembly;
}

export function AssemblyExpandedDetails({ assembly }: Props) {
  const [value, setValue] = useState(0);

  const handleChange = (_: SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="Assembly details tabs"
        >
          <Tab label="Build information" />
          <Tab label="Parts used" />
          <Tab label="Notes" />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <AssemblyBuildInformation assembly={assembly} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <AssemblyPartsUsed partsUsed={assembly.partsUsed} />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <AssemblyNotesTab note={assembly.note} />
      </TabPanel>
    </Box>
  );
}
